import React, { useState, useEffect, useCallback } from 'react';
import { Box } from '@mui/material';
import DashboardLayout from './DashboardLayout'; // Ensure this path is correct
import HelpCenterPage from './HelpCenter/HelpCenter'; // Path corrected
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../user/config';
import PageLoader from '../../../Reusable/PageLoader'; // <-- import PageLoader

const HelpCenter = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchRequests = useCallback(async () => {
        setLoading(true);
        try {
             //   await new Promise(resolve => setTimeout(resolve, 4000));

            const response = await fetch(`${baseURL}/org/tickets`, { credentials: "include" });
            const data = await response.json();

            if (!response.ok) throw new Error(data.message || "Failed to load messages.");

            setRequests(data.tickets || []);
        } catch (err) {
            toast.error(err.message || "Failed to load messages");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchRequests();
    }, [fetchRequests]);

    return (
        <DashboardLayout>
            {loading && <PageLoader />} {/* Loader inside layout */}

            {!loading && (
                <Box sx={{ p: 3 }}>
                    <HelpCenterPage 
                        requests={requests} 
                        onTicketSubmitted={fetchRequests} // Re-fetch function
                    />
                </Box>
            )}
        </DashboardLayout>
    );
};

export default HelpCenter;
